import { NutritionData } from "client/blueChef";
import { RootState } from "store/index";

const nutritionSelector = (state: RootState): NutritionData[] | undefined =>
  state.recipeDetail.recipe?.nutrition_records;

export default nutritionSelector;
